import React from 'react';
import { trackPixelEvent } from '../MetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  targetId?: string;
  pixelEvent?: string;
  pixelParams?: Record<string, unknown>;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
}
export function CtaButton({
  children,
  href,
  targetId,
  pixelEvent,
  pixelParams,
  size = 'md',
  fullWidth = false,
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-[11px] sm:px-10 sm:py-5 sm:text-xs' : 'px-7 py-3.5 text-[11px] sm:px-9 sm:py-4 sm:text-xs';
  const base = `btn-gold rounded-full font-sans font-semibold uppercase tracking-[0.18em] leading-snug text-center ${sizing} ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`;
  const fire = () => {
    if (pixelEvent) trackPixelEvent(pixelEvent, pixelParams);
  };
  if (targetId) {
    return <button type="button" onClick={() => {
      fire();
      document.getElementById(targetId)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }} className={base} data-id="element-323" data-mp="185wkox66yj82">
        {children}
      </button>;
  }
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={fire} className={base} data-id="element-324" data-mp="2qhrhgipf0ihj">
      {children}
    </a>;
}